var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2343_129761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2343_129761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 9.75001C9.27799 9.75001 8.66699 9.49667 8.16699 8.99001C7.66699 8.48267 7.41699 7.87501 7.41699 7.16701C7.41699 6.44434 7.66699 5.83301 8.16699 5.33301C8.66699 4.83301 9.27799 4.58301 9.99999 4.58301C10.722 4.58301 11.333 4.83301 11.833 5.33301C12.333 5.83301 12.583 6.44434 12.583 7.16701C12.583 7.87501 12.333 8.48267 11.833 8.99001C11.333 9.49667 10.722 9.75001 9.99999 9.75001ZM4.41699 15.417V13.896C4.41699 13.646 4.49333 13.403 4.64599 13.167C4.79866 12.9303 5.01399 12.722 5.29199 12.542C6.01399 12.1253 6.77433 11.8057 7.57299 11.583C8.37166 11.361 9.18066 11.25 9.99999 11.25C10.8053 11.25 11.611 11.361 12.417 11.583C13.2223 11.8057 13.986 12.1253 14.708 12.542C14.986 12.7087 15.2013 12.9133 15.354 13.156C15.5067 13.3993 15.583 13.646 15.583 13.896V15.417H4.41699ZM5.49999 14.333H14.5V13.896C14.5 13.8127 14.4687 13.7327 14.406 13.656C14.3433 13.58 14.2567 13.514 14.146 13.458C13.5347 13.0973 12.8783 12.8197 12.177 12.625C11.4757 12.4303 10.75 12.333 9.99999 12.333C9.24999 12.333 8.52433 12.4303 7.82299 12.625C7.12166 12.8197 6.46533 13.0973 5.85399 13.458C5.74333 13.5413 5.65666 13.618 5.59399 13.688C5.53133 13.7573 5.49999 13.8267 5.49999 13.896V14.333ZM9.99999 8.66701C10.4167 8.66701 10.7707 8.51767 11.062 8.21901C11.354 7.92034 11.5 7.56267 11.5 7.14601C11.5 6.74334 11.354 6.39601 11.062 6.10401C10.7707 5.81267 10.4167 5.66701 9.99999 5.66701C9.58333 5.66701 9.22933 5.81267 8.93799 6.10401C8.64599 6.39601 8.49999 6.75034 8.49999 7.16701C8.49999 7.58367 8.64599 7.93767 8.93799 8.22901C9.22933 8.52101 9.58333 8.66701 9.99999 8.66701Z",
    fill: "#686B7A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUser);
export default __webpack_public_path__ + "static/media/filter-user.1ef45933088fad9737ba91ca1b48c41a.svg";
export { ForwardRef as ReactComponent };